// IP Geolocation service to detect user's country

const COUNTRY_TO_LANGUAGE = {
  'NL': 'nl',
  'BE': 'nl', // Belgium defaults to Dutch, can be changed by user
  'DE': 'de',
  'FR': 'fr',
  'AT': 'de', // Austria
  'CH': 'de', // Switzerland (German-speaking part)
  'LU': 'fr', // Luxembourg
};

export const detectCountryFromIP = async () => {
  try {
    // Using ipapi.co free API (no key required, 30k requests/month)
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    if (data.country_code) {
      return {
        country: data.country_code,
        language: COUNTRY_TO_LANGUAGE[data.country_code] || 'en'
      };
    }
  } catch (error) {
    console.warn('IP geolocation failed, using default language');
  }
  
  return { country: null, language: 'en' };
};

export const getLanguageForCountry = (countryCode) => {
  return COUNTRY_TO_LANGUAGE[countryCode] || 'en';
};
